import React, { FC, useEffect } from 'react'
import { observer } from 'mobx-react'
import { CartItems, CartFooter, CheckoutItems, CartCheck } from './component'
import { IonPage, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react'
import { memberMobx, deliveryMobx } from '@mobxStore'
import { MallController } from '@ctrls/mallController'
import './index.scss'

interface IProps { }

const Cart: FC<IProps> = ({ }) => {
  useEffect(() => {
    return () => {
      MallController.outCheckout()
    }
  }, [])

  const setAddress = async () => {
    await memberMobx.getMemberAddress()
    if (memberMobx.addressList) {
      deliveryMobx.setAddress(memberMobx.addressList[0], 'mall')
    }
  }

  useIonViewDidEnter(() => {
    // 从登录返回后需要获取收货地址
    memberMobx.isLogin && !memberMobx.addressList.length && setAddress()
  })

  return (
    <IonPage className='mall-cart-page'>
      <CartCheck>
        <CartItems />
        <CheckoutItems />
      </CartCheck>
      <CartFooter />
    </IonPage>
  )
}

export default observer(Cart)
